import { useEffect, useState } from 'react'
import { Lock } from 'lucide-react'
import { NUR_LESEN_EVENT, useUmgebung } from '../lib/umgebung'

/**
 * Auf Test steht über jeder Seite: Inhalte nur lesen. Der Worker weist das
 * Speichern von Inhalten ab (middleware/read-only.ts) — technische
 * Einstellungen unter Konfiguration gehen; versucht es jemand trotzdem, hebt
 * sich der Streifen kurz hervor und zeigt die Meldung des Servers — damit
 * sie sichtbar ist, egal wie die Seite Fehler sonst anzeigt.
 */
export function NurLesenBanner() {
  const umgebung = useUmgebung()
  const [versucht, setVersucht] = useState<string | null>(null)

  useEffect(() => {
    const onVersuch = (e: Event) => {
      setVersucht((e as CustomEvent<string>).detail)
      const t = setTimeout(() => setVersucht(null), 8000)
      return () => clearTimeout(t)
    }
    window.addEventListener(NUR_LESEN_EVENT, onVersuch)
    return () => window.removeEventListener(NUR_LESEN_EVENT, onVersuch)
  }, [])

  if (umgebung !== 'staging') return null
  return (
    <div
      role={versucht ? 'alert' : 'status'}
      data-testid="nur-lesen"
      className={`mb-5 flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm ${
        versucht
          ? 'border-status-error bg-status-error/10 text-text'
          : 'border-border bg-surface text-text-muted'
      }`}
    >
      <Lock size={18} className="mt-0.5 shrink-0" aria-hidden="true" />
      <div>
        <p className="font-semibold text-text">Testumgebung: Inhalte nur lesen</p>
        <p>
          {versucht ??
            'Showcases, Wissen, Dokumente, Texte und Persönlichkeit werden im Production-Admin gepflegt (admin.k4ia.ai) und per „Nach Test synchronisieren“ hierher übertragen. Technische Einstellungen unter Konfiguration lassen sich hier ändern und bleiben beim Abgleich erhalten.'}
        </p>
      </div>
    </div>
  )
}
